import { NgModule } from '@angular/core';

import { SharedModule }            from '../shared/shared.module';
import { StripeCheckoutComponent } from './stripe.checkout.component';
import { StripePaymentComponent }  from './stripe.payment.component';
import { StripeService }           from './stripe.service';
import { StripeStatusPipe }        from './stripe.status.pipe';

@NgModule({
  declarations: [
    StripeCheckoutComponent,
    StripePaymentComponent,
    StripeStatusPipe,
  ],
  entryComponents: [
    StripeCheckoutComponent,
    StripePaymentComponent
  ],
  exports: [
    StripeCheckoutComponent,
    StripePaymentComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    StripeService,
    StripeStatusPipe
  ]
})
export class StripeModule {}